import React, { useEffect, useMemo, useState } from "react";
import { Flame } from "lucide-react";

function computeParts(target) {
  const diff = target.getTime() - Date.now();
  if (diff <= 0) return { expired: true, d: 0, h: 0, m: 0, s: 0 };
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { expired: false, d, h, m, s };
}

export default function PromoCountdown({ endsAt, variant = "card" }) {
  const target = useMemo(() => (endsAt ? new Date(endsAt) : null), [endsAt]);
  const [parts, setParts] = useState(() =>
    target ? computeParts(target) : null
  );

  useEffect(() => {
    if (!target) return;
    const t = setInterval(() => setParts(computeParts(target)), 1000);
    return () => clearInterval(t);
  }, [target]);

  if (!target || !parts) return null;
  if (parts.expired) {
    return variant === "banner" ? (
      <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-[#475569]">
        Offre terminée
      </div>
    ) : null;
  }

  const cells = [
    { v: parts.d, l: "j" },
    { v: parts.h, l: "h" },
    { v: parts.m, l: "min" },
  ];

  if (variant === "banner") {
    return (
      <div
        data-testid="promo-countdown-banner"
        className="inline-flex items-center gap-4 bg-[#0a192f] text-[#efeade] px-6 py-4 border border-[#c05c3d]/40"
      >
        <Flame size={16} strokeWidth={1.5} className="text-[#c05c3d]" />
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#b08d57]">
          Offre limitée · reste
        </div>
        <div className="flex items-baseline gap-3">
          {cells.map((c, i) => (
            <div key={c.l} className="flex items-baseline gap-1">
              <span className="font-serif text-3xl md:text-4xl leading-none tabular-nums text-[#fbeacc]">
                {String(c.v).padStart(2, "0")}
              </span>
              <span className="text-[10px] tracking-[0.2em] uppercase text-[#efeade]/60">
                {c.l}
              </span>
              {i < cells.length - 1 && (
                <span className="text-[#efeade]/25 ml-2">·</span>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="promo-countdown"
      className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-semibold text-[#c05c3d]"
    >
      <Flame size={12} strokeWidth={1.6} />
      Reste {parts.d}j {String(parts.h).padStart(2, "0")}h{" "}
      {String(parts.m).padStart(2, "0")}min
    </div>
  );
}
